module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"month1":"января","month2":"февраля","month3":"марта","month4":"апреля","month5":"мая","month6":"июня","month7":"июля","month8":"августа","month9":"сентября","month10":"октября","month11":"ноября","month12":"декабря"}}')
  delete Component.options._Ctor
}
